import { constant, mapValues, noop, update } from 'lodash/fp';
import { whenIsNil } from '@mews/fp';

export const updateNilEventHandlersWithNoop = update('input', mapValues(whenIsNil(constant(noop))));
